// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__12mMa","left":"StickyBox_left__1osFl","right":"StickyBox_right__1Ly0S"};